(function(){
'use strict';

scFundraisingPageModelFactory.$inject = ["$http", "$q", "scObjectModel", "scMembersService", "scCampaignsService", "scFundraisingPageDefaults", "scFundraisingPostsDemo", "scCloneDeep", "scPageAccessService", "scFacebook", "scBanner", "scBlocksService", "$state"];
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/**
 * @ngDoc factory
 * @name scFundraisingPageModel
 *
 * @description
 * A campaign constructor with some common
 * prototype methods.
 */

function scFundraisingPageModelFactory($http, $q, scObjectModel, scMembersService, scCampaignsService, scFundraisingPageDefaults, scFundraisingPostsDemo, scCloneDeep, scPageAccessService, scFacebook, scBanner, scBlocksService, $state) {
  var checkDashboardAccess = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(pageType) {
      var pageOwner, currentMember, hasPageAdminAccess;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              pageOwner = _.get(this, 'current.member_id', false);
              currentMember = _.get(scMembersService, 'active.current.id', null);
              _context.next = 4;
              return scPageAccessService.checkPageAdminAccess(pageType);

            case 4:
              hasPageAdminAccess = _context.sent;
              return _context.abrupt('return', currentMember && pageOwner == currentMember || hasPageAdminAccess);

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function checkDashboardAccess(_x2) {
      return _ref.apply(this, arguments);
    };
  }();

  function scFundraisingPageModel(data, demo) {
    scObjectModel.call(this);

    this.isNew = !data && !demo;
    this.isDemo = !!demo;

    this.type = 'fundraising-pages';
    this.saved = scCloneDeep(data || {});
    this.current = scCloneDeep(data || {});
    this.defaults = scCloneDeep(scFundraisingPageDefaults);
  }

  // Constructor
  scFundraisingPageModel.prototype = _.create(scObjectModel.prototype, {
    constructor: scFundraisingPageModel
  });

  // Methods
  scFundraisingPageModel.prototype.joinTeam = joinTeam;
  scFundraisingPageModel.prototype.leaveTeam = leaveTeam;
  scFundraisingPageModel.prototype.getTeam = getTeam;
  scFundraisingPageModel.prototype.getPosts = getPosts;
  scFundraisingPageModel.prototype.getStory = getStory;
  scFundraisingPageModel.prototype.createPost = createPost;
  scFundraisingPageModel.prototype.create = create;
  scFundraisingPageModel.prototype.checkDashboardAccess = checkDashboardAccess;
  scFundraisingPageModel.prototype.refreshData = refreshData;
  scFundraisingPageModel.prototype.getDesignation = getDesignation;
  scFundraisingPageModel.prototype.registerObserverCallback = registerObserverCallback;
  scFundraisingPageModel.prototype.getAlias = getAlias;
  scFundraisingPageModel.prototype.createChannelFundraisingPage = createChannelFundraisingPage;
  scFundraisingPageModel.prototype.getChannelFundraisingPage = getChannelFundraisingPage;

  var observerCallbacks = [];

  /* ---------------------------------------------------------------- *
   * Implementation
   * ---------------------------------------------------------------- */

  // public method, register an observer. Called when you need to watch for team
  // changes within an isolate scope to avoid super complex $watch patterns
  function registerObserverCallback(callback) {
    observerCallbacks.push(callback);
  }

  // call this below when you know the team has been changed
  function notifyObservers(current) {
    angular.forEach(observerCallbacks, function (callback) {
      callback(current);
    });
  }

  function joinTeam(teamId) {
    var _this = this;

    var pageId = this.current.id;

    return $http.post('/frs-api/fundraising-pages/' + pageId + '/transfers', {
      fundraising_team_id: teamId
    }).then(function (response) {
      _this.current.fundraising_team_id = response.data.destination_fundraising_team_id;
    });
  }

  function leaveTeam() {
    var _this2 = this;

    var pageId = this.current.id;
    return $http.post('/frs-api/fundraising-pages/' + pageId + '/transfers', {
      fundraising_team_id: null
    }).then(function () {
      _this2.current.fundraising_team_id = null;
    });
  }

  function getTeam() {
    var teamId = this.current.fundraising_team_id;

    if (this.isDemo || !teamId) {
      return $q.resolve({});
    }

    return $http({
      method: 'GET',
      url: '/frs-api/fundraising-teams/' + teamId
    });
  }

  function getPosts() {
    var memberId = _.get(scMembersService, 'active.current.id', null);
    if (this.isNew && !this.current.id) {
      return $q.resolve(null);
    } else if (this.isDemo) {
      return $q.resolve({ data: scFundraisingPostsDemo(this.current.id) });
    }
    return $http({
      method: 'GET',
      url: '/frs-api/fundraising-pages/' + this.current.id + '/updates',
      params: {
        member_id: memberId
      }
    });
  }

  function getStory() {
    var memberId = _.get(scMembersService, 'active.current.id', null);
    if (this.isNew && !this.current.id) {
      return $q.resolve(null);
    } else if (this.isDemo) {
      return $q.resolve({ data: scFundraisingPostsDemo(this.current.id) });
    }
    return $http({
      method: 'GET',
      url: '/frs-api/fundraising-pages/' + this.current.id + '/stories',
      params: {
        member_id: memberId
      }
    });
  }

  function createPost(post) {
    var postcopy = _.cloneDeep(post);
    postcopy.status = 'published';

    return $http({
      method: 'POST',
      url: '/frs-api/fundraising-pages/' + this.current.id + '/updates',
      data: postcopy
    });
  }

  function create(options) {
    var _this3 = this;

    var optIn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var url = '';

    if (options.teamId) {
      url = '/frs-api/fundraising-teams/' + options.teamId + '/fundraising-pages';
    } else {
      url = '/frs-api/campaign/' + options.campaignId + '/fundraising-pages';
    }

    var postData = scCloneDeep(this.current);

    if (scCampaignsService.active.multiCurrencyDisabled()) {
      delete postData.raw_currency_code;
    } else {
      postData.raw_goal = postData.goal;
      delete postData.goal;
    }

    if (postData.answers && postData.answers.length) {
      postData.answers = postData.answers.filter(function (answer) {
        return answer.answer !== '';
      });
    }

    if (optIn.opted_in != null && optIn.opt_in_wording != null) {
      postData.opted_in = optIn.opted_in;
      postData.opt_in_wording = optIn.opt_in_wording;
    }

    if (options.token) {
      postData.token = options.token;
    }

    return $http({
      url: url,
      method: 'POST',
      data: postData
    }).then(function (response) {
      _this3.current = scCloneDeep(response.data);
      _this3.saved = scCloneDeep(response.data);
      return response;
    });
  }

  function refreshData() {
    var _this4 = this;

    return $http({
      method: 'GET',
      url: '/frs-api/fundraising-pages/' + this.current.id
    }).then(function (response) {
      var updateableData = ['average_donation', 'commitment', 'goal', 'raw_currency_code', 'raw_goal', 'largest_donation', 'percent_to_goal', 'total_donations', 'total_donors', 'total_raised', 'ended_at', 'end_date'];
      var updatedData = _.pick(response.data, updateableData);
      _.assign(_this4.current, updatedData);
      notifyObservers(_this4.current);
      return response;
    });
  }

  function getDesignation() {
    return $http({
      method: 'GET',
      url: '/frs-api/campaign/' + this.current.campaign_id + '/designations',
      params: {
        per_page: 1,
        filter: 'id=' + this.current.designation_id
      }
    });
  }

  function getAlias() {
    this.current.alias = this.current.alias || this.current.name;
    return this.current.alias || this.current.name;
  }

  function createChannelFundraisingPage(channelName) {
    var _this5 = this;

    var deferred = $q.defer();
    var pageBlock = scBlocksService.getBlockByType('fundraiser');

    scFacebook.authenticate(_.get(SC, 'organization.facebookChannel.appId', 0), channelName).then(function (FB) {
      var data = {
        channel_name: channelName,
        user_access_token: FB.getAccessToken(),
        cover_photo_url: _.get(pageBlock, 'current.background.image.asset.src', null)
      };

      return $http({
        url: 'frs-api/fundraising-pages/' + _this5.current.id + '/channels',
        method: 'POST',
        data: data
      }).then(function (_response) {
        deferred.resolve();
      }).catch(function (_error) {
        scBanner('Oops! Something went wrong. Please try again.', 'error');
        deferred.reject();
      });
    });
    return deferred.promise;
  }

  function getChannelFundraisingPage(channelName) {
    var promises = [];
    promises.push($http({
      url: 'frs-api/fundraising-pages/' + $state.params.fundraisingPageId + '/channels',
      method: 'GET',
      params: {
        filter: 'channel_name=' + channelName + ',fundraising_entity_type=fundraising_page,deleted_at=null'
      }
    }).then(function (fbResponse) {
      if (_.find(fbResponse.data.data)) return $http.get('frs-api/channel-fundraising-entities/' + _.find(fbResponse.data.data).id).then(function (response) {
        return response.data;
      }).catch(function (_error) {
        scBanner('Oops! Something went wrong. Please try again.', 'error');
      });
      return _.find(fbResponse.data.data);
    }).catch(function (_error) {
      scBanner('Oops! Something went wrong. Please try again.', 'error');
    }));
    promises.push($http.get('frs-api/fundraising-pages/' + $state.params.fundraisingPageId).then(function (response) {
      return response.data;
    }).catch(function (_error) {
      scBanner('Oops! Something went wrong. Please try again.', 'error');
    }));
    return $q.all(promises).then(function (response) {
      return {
        data: response
      };
    });
  }

  return scFundraisingPageModel;
}

angular.module('classy').factory('scFundraisingPageModel', scFundraisingPageModelFactory);
})();